import { memo, useCallback, useEffect } from 'react';
import DropdownButton from './DropdownButton';
import { ANIMATION_DURATION, DELIVERY_METHOD_NAMES, DISPLAY_STATES, TEASE_ALERT_MINIMUM_TIMEOUT } from '../../constants';
import { useFloatingNotificationState } from '../../hooks/useFloatingNotificationState';
import { markNotificationAsClicked } from '../../utils/TrackingUtils';
import { isExampleNotification } from '../../utils/IsExampleNotification';
import { TeaseDisplay } from 'notifications-display';
import { jsx as _jsx } from "react/jsx-runtime";
const TeaseNotification = ({
  notification,
  playSound,
  soundDuration
}) => {
  const {
    displayState,
    handleAnimationEnd,
    handleCloseNotification,
    handleCloseOnClick,
    isHovered,
    linkUrl,
    setIsHovered
  } = useFloatingNotificationState({
    autoCloseDuration: Math.max(TEASE_ALERT_MINIMUM_TIMEOUT, soundDuration),
    deliveryMethod: DELIVERY_METHOD_NAMES.TEASE,
    initialDisplayState: DISPLAY_STATES.OPEN,
    notification
  });
  useEffect(() => {
    playSound();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onMouseEnter = useCallback(() => setIsHovered(true), [setIsHovered]);
  const onMouseLeave = useCallback(() => setIsHovered(false), [setIsHovered]);
  const onNotificationClicked = useCallback(() => markNotificationAsClicked(notification, DELIVERY_METHOD_NAMES.TEASE), [notification]);
  const {
    context,
    type,
    translatedTemplate: {
      body,
      subject
    }
  } = notification;
  const notificationType = typeof type === 'number' ? type : 0;
  return /*#__PURE__*/_jsx(TeaseDisplay, {
    animationDurationMs: ANIMATION_DURATION,
    body: body,
    context: context,
    displayState: displayState,
    handleAnimationEnd: handleAnimationEnd,
    handleCloseNotification: handleCloseNotification,
    handleCloseOnClick: handleCloseOnClick,
    isExample: isExampleNotification(notification),
    isHovered: isHovered,
    linkUrl: linkUrl,
    notificationType: notificationType,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onNotificationClicked: onNotificationClicked,
    subject: subject,
    renderDropdown: useCallback(({
      handleDismissTease,
      smallerClickArea
    }) => /*#__PURE__*/_jsx(DropdownButton, {
      handleDismissTease: handleDismissTease,
      notification: notification,
      showButton: isHovered,
      smallerClickArea: smallerClickArea
    }), [notification, isHovered])
  });
};
export default /*#__PURE__*/memo(TeaseNotification);